"use strict";
import React from "react";
import Auth from "../util/auth";
const BeamerUpdates = React.createClass(
  {
    getInitialState: function() {
      return { messageCount: 0 };
    },
    componentDidMount: function() {
      this.handleInitBeamer();
    },
    handleClickBeamer: function() {
      if (typeof Beamer !== "undefined") {
        Beamer.show();
        this.setState({ messageCount: 0 });
      }
    },
    handleInitBeamer: function() {
      var _a;
      const user = Auth.getCurrentUser();
      if (user && user.account && typeof Beamer !== "undefined") {
        const isFactorAccount = user.account.factor_account;
        const isNextGenAudit = ((_a = user.account.settings) == null ? void 0 : _a.next_gen_audit) || false;
        const config = {
          callback: this.handleSetMessageCount,
          filter: (isFactorAccount ? "factor" : "broker") + ";payables",
          user_email: user.email,
          user_id: user.id,
          next_gen_audit: isNextGenAudit
        };
        Beamer.update(config);
        Beamer.init();
      }
    },
    handleSetMessageCount: function(messageCount) {
      this.setState({ messageCount });
    },
    render: function() {
      const { messageCount } = this.state;
      return /* @__PURE__ */ React.createElement("a", { "data-component": "BeamerUpdates", onClick: this.handleClickBeamer }, "Updates", messageCount ? ` (${messageCount})` : "");
    }
  }
);
export default BeamerUpdates;
